module.exports = __webpack_public_path__ + "static/media/frown.277a886e.svg";